<template>
  <PageWrapper type="signin" class="LoginView">
    <FormLogo slot="logo" />

    <FormSignin slot="signin" />

    <PageContent slot="content" />
  </PageWrapper>
</template>

<script>
import PageWrapper from '@/components/login/PageWrapper.vue'
import PageContent from '@/components/login/PageContent.vue'
import FormLogo from '@/components/login/FormLogo.vue'
import FormSignin from '@/components/login/FormSignin.vue'

export default {
  name: 'Login',
  components: {
    PageWrapper,
    PageContent,
    FormLogo,
    FormSignin
  }
}
</script>

<style>
.kt-login__form .form-control::placeholder{
  color:#032647!important;
  font-weight: 500!important;
}
</style>
